import React, { useState } from 'react';
import ScrollContainer from '../../../../Base/Components/ScrollContainer';
import {
	NcziEnum,
	useLazyNcziListEnumsQuery,
} from '../../../../../graphql/graphql';
import { useEffectAsync } from '../../../../../helpers';

//@ts-ignore
import styles from './EnumsList.module.scss';
import Loading from '../../../../../Components/Loading';
import EnumListItem from './EnumListItem';

interface Props {
	setIsLoading: (isLoading: boolean) => void;
}

const EnumsList: React.FC<Props> = () => {
	const [getEnumList] = useLazyNcziListEnumsQuery();
	const [items, setItems] = useState<NcziEnum[]>([]);

	useEffectAsync(async () => {
		if (!items.length) {
			const { result } = await getEnumList().unwrap();
			const tmpItems = [];
			for (const item of result?.data || []) {
				if (item) {
					tmpItems.push(item);
				}
			}
			setItems(tmpItems);
		}
	}, []);

	return (
		<div className={styles.wrapper}>
			<div className={styles.contentWrapper}>
				<ScrollContainer>
					<div className={styles.content}>
						{!items.length && (
							<div className={styles.loadingWrapper}>
								<Loading />
							</div>
						)}
						{items.map(item => (
							<EnumListItem key={item.oid} item={item} />
						))}
					</div>
				</ScrollContainer>
			</div>
		</div>
	);
};

export default EnumsList;
